import { TourStatusForZcheduler } from '@zg-rentals/ts-z-calendar-client';

export const getTourStatusTone = (tourStatus?: TourStatusForZcheduler) => {
  switch (tourStatus) {
    case TourStatusForZcheduler.CANCELLED:
      return 'critical';
    case TourStatusForZcheduler.CONFIRMED:
      return 'green';
    case TourStatusForZcheduler.DECLINED:
      return 'red';
    case TourStatusForZcheduler.REQUESTED:
      return 'blue';
    case TourStatusForZcheduler.EXPIRED:
      return 'yellow';
    default:
      return 'purple';
  }
};

export const getTourStatusTagLabel = (tourStatus: TourStatusForZcheduler): string | undefined => {
  switch (tourStatus) {
    case TourStatusForZcheduler.CANCELLED:
      return 'Canceled tour';
    case TourStatusForZcheduler.CONFIRMED:
      return 'Booked tour';
    case TourStatusForZcheduler.DECLINED:
      return 'Declined tour';
    case TourStatusForZcheduler.EXPIRED:
      return 'Expired tour';
    case TourStatusForZcheduler.REQUESTED:
      return 'Requested tour';
    default:
      return undefined;
  }
};
